import { all } from 'redux-saga/effects';

import fetchIotConfig from './fetchIotConfig';

export default function* () {
    yield all([fetchIotConfig()]);
}
